// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.app-select[data-v-15fbf42b]{\n\tmin-width: 200px;\n}\n.mr[data-v-15fbf42b] {\n\tmargin-right: 10px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
